import React from 'react'

export const ChatBubbleIcon = ({
  width = 32,
  height = 32,
  dotColor = '#0cc18c',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
      fill="white"
    />
    <circle cx="8" cy="10" r="1.5" fill={dotColor} />
    <circle cx="12" cy="10" r="1.5" fill={dotColor} />
    <circle cx="16" cy="10" r="1.5" fill={dotColor} />
  </svg>
)

export const ChatBubbleSmallIcon = ({ width = 18, height = 18 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path
      d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
      fill="white"
    />
  </svg>
)
